import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL_SANDBOX,
  SET_POPULAR_PRODUCTS,
  BASE_URL_FOR_ELASTIC_SEARCH
} from '../../../Constants/Config';

const initialState = {
  loading: false,
  shopByPopularProductList: [],
  error: '',
  totalPages: 0,
  hasMore: true,
};

export const fetchShopByPopularProductLists = createAsyncThunk(
  'shopByPopularProductList/fetchShopByPopularProductLists',
  async ({ lat, long, store, signal, forceRefresh }, { rejectWithValue, getState }) => {
    try {
      const { shopByPopularProductList, totalPages } = getState().shopByPopularProductList;

      if (shopByPopularProductList.length > 0 && !forceRefresh) {
        return {
          shopByPopularProductList,
          totalPages,
        };
      }

      const formData = new FormData();

      formData.append('lat', lat || '');
      formData.append('long', long || '');
      formData.append('store', store || '');
      const response = await axios.post(
        `${BASE_URL_SANDBOX}${SET_POPULAR_PRODUCTS}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }, signal },
      );

      if (response.status === 200 && response.data && Array.isArray(response.data.data)) {
        const shopBYStoreList = response.data.data;

        return {
          shopByPopularProductList: shopBYStoreList,
          totalPages: response?.data?.totalPages,
        };
      }

      return { shopByPopularProductList: [], totalPages: 0, hasMore: false };
    } catch (e) {
      return rejectWithValue(e.message);
    }
  },
);

const shopByPopularProductSlice = createSlice({
  name: 'shopByPopularProductList',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchShopByPopularProductLists.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShopByPopularProductLists.fulfilled, (state, action) => {
        state.loading = false;
        state.shopByPopularProductList =
          action.payload?.shopByPopularProductList;
        state.totalPages = action.payload?.totalPages || 0;
        state.error = '';
      })
      .addCase(fetchShopByPopularProductLists.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || 'Failed to fetch  Shop by Best Sellers Near You';
        state.hasMore = false;
      });
  },
});

export default shopByPopularProductSlice.reducer;
